import React from 'react';
import Table from 'react-bootstrap/Table';
import { HistoriquePrixProduit } from '../../../../../common/src/entities';

interface DynamicTableCommissionProps {
    data: HistoriquePrixProduit;
    title: string;
}

const DynamicTableCommission: React.FC<DynamicTableCommissionProps> = ({ data, title }) => {
    return (
        <div>
            <p>{title}</p>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>commission (%):</th>
                        <th>commission ($):</th>
                        <th>surfacturation (%):</th>
                        <th>surfacturation ($):</th>
                    </tr>
                </thead>
                <tbody>
                    <td>{data.facturation?.valeur_commission_pourcentage} </td>
                    <td>{data.facturation?.valeur_commission_dollar}</td>
                    <td>{data.facturation?.valeur_surfacturation_pourcentage}</td>
                    <td>{data.facturation?.valeur_surfacturation_dollar}</td>
                </tbody>
            </Table>
        </div>
    );
};

export default DynamicTableCommission;
